export default "__VITE_ASSET__UyZ1QCIU__"